
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderCombinedReportDialog extends Serenity.EntityDialog<OrderCombinedReportRow, any> {
        protected getFormKey() { return OrderCombinedReportForm.formKey; }
        protected getIdProperty() { return OrderCombinedReportRow.idProperty; }
        protected getLocalTextPrefix() { return OrderCombinedReportRow.localTextPrefix; }
        protected getNameProperty() { return OrderCombinedReportRow.nameProperty; }
        protected getService() { return OrderCombinedReportService.baseUrl; }
        protected getDeletePermission() { return OrderCombinedReportRow.deletePermission; }
        protected getInsertPermission() { return OrderCombinedReportRow.insertPermission; }
        protected getUpdatePermission() { return OrderCombinedReportRow.updatePermission; }

        protected form = new OrderCombinedReportForm(this.idPrefix);

    }
}